module.exports = __webpack_public_path__ + "static/media/undraw_add_to_cart_vkjp.d11196fd.svg";